var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDrm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.6895,
    y: 16,
    width: 43.78,
    height: 43.78,
    rx: 8,
    fill: "#1E2A10"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1881_1916)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.6807,
    cy: 37.7793,
    r: 13.1094,
    fill: "#AAEF77"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7349 53.503C49.3582 53.503 56.3487 46.5125 56.3487 37.8892C56.3487 29.2659 49.3582 22.2754 40.7349 22.2754C32.1116 22.2754 25.1211 29.2659 25.1211 37.8892C25.1211 46.5125 32.1116 53.503 40.7349 53.503Z",
    fill: "#AAEF77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7349 53.503C49.3582 53.503 56.3487 46.5125 56.3487 37.8892C56.3487 29.2659 49.3582 22.2754 40.7349 22.2754C32.1116 22.2754 25.1211 29.2659 25.1211 37.8892C25.1211 46.5125 32.1116 53.503 40.7349 53.503Z",
    fill: "url(#paint0_linear_1881_1916)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7349 53.503C49.3582 53.503 56.3487 46.5125 56.3487 37.8892C56.3487 29.2659 49.3582 22.2754 40.7349 22.2754C32.1116 22.2754 25.1211 29.2659 25.1211 37.8892C25.1211 46.5125 32.1116 53.503 40.7349 53.503Z",
    fill: "url(#paint1_radial_1881_1916)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3555 37.5347L38.5364 31.6409C38.3618 31.5501 38.1672 31.5044 37.9704 31.508C37.7736 31.5117 37.5808 31.5646 37.4097 31.6618C37.2386 31.7591 37.0945 31.8977 36.9907 32.0649C36.8869 32.2322 36.8267 32.4228 36.8154 32.6193V44.4069C36.8267 44.6034 36.8869 44.794 36.9907 44.9613C37.0945 45.1285 37.2386 45.2671 37.4097 45.3644C37.5808 45.4617 37.7736 45.5146 37.9704 45.5182C38.1672 45.5219 38.3618 45.4762 38.5364 45.3853L48.3555 39.4915C48.516 39.3837 48.6474 39.238 48.7383 39.0674C48.8292 38.8968 48.8768 38.7064 48.8768 38.5131C48.8768 38.3198 48.8292 38.1294 48.7383 37.9588C48.6474 37.7882 48.516 37.6426 48.3555 37.5347Z",
    fill: "#212E12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3555 37.5347L38.5364 31.6409C38.3618 31.5501 38.1672 31.5044 37.9704 31.508C37.7736 31.5117 37.5808 31.5646 37.4097 31.6618C37.2386 31.7591 37.0945 31.8977 36.9907 32.0649C36.8869 32.2322 36.8267 32.4228 36.8154 32.6193V44.4069C36.8267 44.6034 36.8869 44.794 36.9907 44.9613C37.0945 45.1285 37.2386 45.2671 37.4097 45.3644C37.5808 45.4617 37.7736 45.5146 37.9704 45.5182C38.1672 45.5219 38.3618 45.4762 38.5364 45.3853L48.3555 39.4915C48.516 39.3837 48.6474 39.238 48.7383 39.0674C48.8292 38.8968 48.8768 38.7064 48.8768 38.5131C48.8768 38.3198 48.8292 38.1294 48.7383 37.9588C48.6474 37.7882 48.516 37.6426 48.3555 37.5347Z",
    fill: "url(#paint2_linear_1881_1916)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0091 62.8624L26.5495 63.6569C26.4111 63.7332 26.2555 63.7732 26.0974 63.7732C25.9393 63.7732 25.7838 63.7332 25.6453 63.6569L24.3536 62.9271C22.3018 61.7584 20.5964 60.0669 19.4108 58.0248C18.2253 55.9828 17.602 53.663 17.6045 51.3018V44.9595C17.6045 44.7026 17.7066 44.4562 17.8883 44.2745C18.0699 44.0928 18.3163 43.9908 18.5733 43.9908C21.1709 43.4389 23.8234 43.1875 26.4785 43.2415C31.4903 43.2415 34.022 43.9908 34.022 43.9908C34.2789 43.9908 34.5253 44.0928 34.707 44.2745C34.8887 44.4562 34.9908 44.7026 34.9908 44.9595V51.1145C34.9914 53.5196 34.3432 55.8804 33.1145 57.9479C31.8857 60.0155 30.122 61.7133 28.0091 62.8624Z",
    fill: "#AAEF77"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0091 62.8624L26.5495 63.6569C26.4111 63.7332 26.2555 63.7732 26.0974 63.7732C25.9393 63.7732 25.7838 63.7332 25.6453 63.6569L24.3536 62.9271C22.3018 61.7584 20.5964 60.0669 19.4108 58.0248C18.2253 55.9828 17.602 53.663 17.6045 51.3018V44.9595C17.6045 44.7026 17.7066 44.4562 17.8883 44.2745C18.0699 44.0928 18.3163 43.9908 18.5733 43.9908C21.1709 43.4389 23.8234 43.1875 26.4785 43.2415C31.4903 43.2415 34.022 43.9908 34.022 43.9908C34.2789 43.9908 34.5253 44.0928 34.707 44.2745C34.8887 44.4562 34.9908 44.7026 34.9908 44.9595V51.1145C34.9914 53.5196 34.3432 55.8804 33.1145 57.9479C31.8857 60.0155 30.122 61.7133 28.0091 62.8624Z",
    fill: "url(#paint3_linear_1881_1916)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0091 62.8624L26.5495 63.6569C26.4111 63.7332 26.2555 63.7732 26.0974 63.7732C25.9393 63.7732 25.7838 63.7332 25.6453 63.6569L24.3536 62.9271C22.3018 61.7584 20.5964 60.0669 19.4108 58.0248C18.2253 55.9828 17.602 53.663 17.6045 51.3018V44.9595C17.6045 44.7026 17.7066 44.4562 17.8883 44.2745C18.0699 44.0928 18.3163 43.9908 18.5733 43.9908C21.1709 43.4389 23.8234 43.1875 26.4785 43.2415C31.4903 43.2415 34.022 43.9908 34.022 43.9908C34.2789 43.9908 34.5253 44.0928 34.707 44.2745C34.8887 44.4562 34.9908 44.7026 34.9908 44.9595V51.1145C34.9914 53.5196 34.3432 55.8804 33.1145 57.9479C31.8857 60.0155 30.122 61.7133 28.0091 62.8624Z",
    fill: "url(#paint4_radial_1881_1916)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0886 34.0168C56.0886 34.0168 62.2781 30.3041 60.8154 28.2677C57.6239 23.7718 15.0946 47.0656 14.3814 50.0733C13.6681 53.081 19.5676 51.1542 19.5676 51.1542",
    stroke: "url(#paint5_linear_1881_1916)",
    strokeWidth: 0.88,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1881_1916",
    x: 0.571289,
    y: 0.669922,
    width: 74.2188,
    height: 74.2188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1881_1916"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1881_1916",
    x1: 12.5457,
    y1: -22.9208,
    x2: 32.9699,
    y2: 63.2661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764629,
    stopColor: "#F8FCF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1881_1916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.4199 81.3159) rotate(-106.066) scale(67.3956 78.3329)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.606936,
    stopColor: "#84D349",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1881_1916",
    x1: 39.7923,
    y1: 37.3207,
    x2: 44.7617,
    y2: 45.0799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#212D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80D11B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1881_1916",
    x1: 28.9,
    y1: 45.5477,
    x2: 25.0068,
    y2: 69.7329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAEF77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764629,
    stopColor: "#F8FCF5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1881_1916",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8275 113.364) rotate(-83.0888) scale(74.1095 74.5329)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.869787,
    stopColor: "#84D349",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84D349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1881_1916",
    x1: 49.0707,
    y1: 14.9811,
    x2: 22.2072,
    y2: 53.7055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FEFFFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FBFFFF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#F8FFFF",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F7FFFF",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F5FFFF",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5FFFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrm);
export default __webpack_public_path__ + "static/media/icon-drm.e2411c001249e256a23a6b6a322aa873.svg";
export { ForwardRef as ReactComponent };